import { OSSAgreementActions } from 'features/oss-agreement/oss-agreement.reducer';
import { toast } from 'react-toastify';
import { all, call, put } from 'redux-saga/effects';
import { ErrorToast } from 'Themes/ScufStyledComponents';

export function* getOSSAgreement(api) {
  const errorText = 'Error retrieving OSS Agreement';
  try {
    const response = yield call(api.getOSSAgreement);   
    if (response.ok) {
      // Add two spaces before each newline to force Markdown line breaks
      const text = response.data.replace(/\r?\n/g, '  \n');
      yield put(OSSAgreementActions.initialOSSAgreementSuccess({content: text}));
    } else {
      yield all([
        put(OSSAgreementActions.initialOSSAgreementFailure(errorText)),
        call(toast, <ErrorToast message={errorText} />),
      ]);
    }
  } catch (error) {
    yield all([
      put(OSSAgreementActions.initialOSSAgreementFailure(errorText)),
      call(toast, <ErrorToast message={errorText} />),
    ]);
  }
}

